import { useEffect, useState } from "react";
import { FeatureGroup } from "react-leaflet";
import {
  AreaUsePurposeTileLayer,
  CITY_PLANNING_DECISION_GIS_DATA_YEAR,
} from "./mapLibre/layers/AreaUsePurposeTileLayer";

interface Props {
  defaultVisible: boolean;
  initialZoomLevel: number;
  tileHost: string | undefined;
  layerName: string;
  visible?: boolean;
  /** Leaflet の attribution コントロールに出す出典文字列 */
  attribution?: string;
}

export const AREA_USE_PURPOSE_LAYER_NAME_NATIONAL_LAND_NUMERICAL_INFORMATION =
  "用途地域を表示する（国土数値情報 2019年）";

const getCityPlanningLayerName = (): string => {
  if (CITY_PLANNING_DECISION_GIS_DATA_YEAR) {
    return `用途地域を表示する（都市計画決定GISデータ ${CITY_PLANNING_DECISION_GIS_DATA_YEAR}年）`;
  }
  return "用途地域を表示する（都市計画決定GISデータ）";
};

export const AREA_USE_PURPOSE_LAYER_NAME_CITY_PLANNING_DECISION_GIS_DATA =
  getCityPlanningLayerName();

/*
AreaUsePurposeTileLayerをLeafletのLayersControlで制御するためのWrapperコンポーネント
*/
export const AreaUsePurposeLayerControlWrapper: React.FC<Props> = ({
  defaultVisible,
  initialZoomLevel,
  tileHost,
  visible: visibleProp,
  attribution,
}) => {
  const [visible, setVisible] = useState(defaultVisible);

  useEffect(() => {
    if (typeof visibleProp === "boolean") {
      setVisible(visibleProp);
    }
  }, [visibleProp]);

  return (
    <>
      {/* 空のFeatureGroupは、LayersControlに認識させるために必要 */}
      <FeatureGroup />
      <AreaUsePurposeTileLayer
        visible={visible}
        initialZoomLevel={initialZoomLevel}
        tileHost={tileHost}
        attribution={attribution}
      />
    </>
  );
};
